export const ProcessStatuses = [
  { name: "Pending", value: 0, badgeClass: "badge-secondary" },
  { name: "Processing", value: 1, badgeClass: "badge-primary" },
  { name: "Completed", value: 2, badgeClass: "badge-success" },
  { name: "N/A", value: 3 },
  { name: "Failure", value: 4, badgeClass: "badge-danger" },
  { name: "Aborted", value: 5, badgeClass: "badge-warning" }
]